import React from 'react'

import { shape, string } from 'prop-types'

function SubcategoryCard({ subcategory }) {
  return (
    <a
      key={subcategory.slug}
      href={subcategory.path}
      className="categories-section__subcategory-card-link"
    >
      <div className="categories-section__subcategory-card">
        <img src={subcategory.image} alt={subcategory.title} className="categories-section__card-image" />
        <div className="categories-section__card-overlay">
          <h3 className="categories-section__card-heading">
            <span className="cgt-legacy-heading-h6 categories-section__card-title">{subcategory.title}</span>
            {subcategory.itemCount && (
              <span className="categories-section__card-count">{subcategory.itemCount}</span>
            )}
          </h3>
        </div>
      </div>
    </a>
  )
}

SubcategoryCard.propTypes = {
  subcategory: shape({
    slug: string.isRequired,
    path: string.isRequired,
    title: string.isRequired,
    image: string.isRequired,
    itemCount: string.isRequired,
  }).isRequired,
}

export default SubcategoryCard
